<style scoped>
.headline {
  background-color: #1b2643;
  width: 100%;
  height: 60px;
}

.active_text {
  border-bottom: 2px solid #ffffff;
  height: 60px;
}

.headline p {
  color: #ffffff;
  font-size: 14px;
}

.content {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}

td {
  border-bottom: 1px solid #dbdbdb;
}
</style>

<template>
  <div>
    <div class="pa-3 headline">
      <p class="active_text">{{ $t('newLearners.simpleSetupDescription') }}</p>
    </div>
    <div class="content pa-10">
      <v-form ref="form">
        <v-row class="mt-10 ">
          <p
            class="text-body-2"
            v-html="$t('newLearners.userTestSetupGuide')"
          ></p>
        </v-row>
        <v-row class="mt-5">
          <v-col cols="7">
            <v-file-input
              accept="text/csv"
              :label="$t('newLearners.newAccountFile')"
              value="a"
              @change="getFileContent"
              persistent-placeholder
              outlined
            ></v-file-input>
          </v-col>
          <v-col cols="5">
            <p class="mt-4">{{ $t('newLearners.formatCSV') }}</p>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api";

type NewStudentType = {
  tempId: string;
  studentId: string;
  tempPassword: string;
};

export default defineComponent({
  name: "NewLearnersView",
  data() {
    return {
      fileName: "",
      students: [] as NewStudentType[],
    };
  },
  methods: {
    getFileContent(e: File) {
      this.fileName = e.name;
      const reader = new FileReader();
      const file = e;
      const students: NewStudentType[] = [];

      const loadFunc = () => {
        if (reader.result !== null) {
          const lines = (reader.result as string).split("\n");
          lines.forEach((element: string) => {
            const studentData = element.split(",");

            // ここの条件分岐はcsvの仕様によって変更
            if (studentData.length === 3) {
              const student = {
                tempId: studentData[0],
                studentId: studentData[1],
                tempPassword: studentData[2],
              };
              students.push(student);
            }
          });
        }
        this.students = students;
      };

      reader.onload = loadFunc;
      reader.readAsBinaryString(file);
    },
  },
});
</script>
